var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9986,
    cy: 13.8408,
    r: 13.3408,
    fill: "#F9F9F9",
    stroke: "#DCDCDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9134 19.7C22.0142 19.84 22.0207 20.027 21.9299 20.1737C21.8392 20.3205 21.669 20.3981 21.4987 20.3705H6.49866C6.32834 20.3981 6.15814 20.3205 6.06737 20.1737C5.9766 20.027 5.98313 19.84 6.08391 19.7L13.6634 4.54174C13.8479 4.17274 14.1494 4.17274 14.3339 4.54174L21.9134 19.7Z",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9987 15.4985V10.2485",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9919 16.9985C13.9424 16.9995 13.8954 17.0203 13.8614 17.0562C13.8275 17.0922 13.8093 17.1403 13.8112 17.1897C13.8152 17.2921 13.8992 17.3732 14.0017 17.3735H14.0054C14.0549 17.3725 14.1019 17.3517 14.1359 17.3158C14.1699 17.2798 14.188 17.2317 14.1862 17.1822C14.1822 17.081 14.1 17.0004 13.9987 16.9985H13.9949",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportant);
export default __webpack_public_path__ + "static/media/important.c0a262006779b12e0b4a7b03878e63c2.svg";
export { ForwardRef as ReactComponent };